import React, { useEffect, useState } from "react";

export interface LoaderProps {
	loadingText?: string[];
	loadingTextStyle?: React.CSSProperties
	timeout?: number;
	classes?: string;
	customLoadingIcon?: React.ReactNode;
}

const Loader: React.FC<LoaderProps> = ({ loadingText, loadingTextStyle, timeout = 5000, classes = "", customLoadingIcon }) => {
	const [index, setIndex] = useState<number>(0);
	const [showText, setShowText] = useState(true);
	useEffect(() => {
		const interval = setInterval(() => {
			if (loadingText && loadingText.length > 1) {
				const next = index + 1 === loadingText.length ? 0 : index + 1;
				setShowText(false);
				setTimeout(() => {
					setIndex(next);
					setTimeout(() => {
						setShowText(true);
					}, 200);
				}, 500);
			}
		}, timeout);
		return () => clearInterval(interval);
	}, [index]);
	return (
		<div className={`loader-screen relative blur-bg ${classes}`}>
			<div className="absolute-center">
				{customLoadingIcon ? (
					customLoadingIcon
				) : (
					<div
						dangerouslySetInnerHTML={{
							__html: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; display: block; shape-rendering: auto; background-position: initial initial; background-repeat: initial initial;" width="324px" height="324px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
<circle cx="50" cy="50" r="0" fill="none" stroke="#3ddc97" stroke-width="2">
  <animate attributeName="r" repeatCount="indefinite" dur="1.7241379310344827s" values="0;16" keyTimes="0;1" keySplines="0 0.2 0.8 1" calcMode="spline" begin="-0.8620689655172413s"></animate>
  <animate attributeName="opacity" repeatCount="indefinite" dur="1.7241379310344827s" values="1;0" keyTimes="0;1" keySplines="0.2 0 0.8 1" calcMode="spline" begin="-0.8620689655172413s"></animate>
</circle>
<circle cx="50" cy="50" r="0" fill="none" stroke="#004bed" stroke-width="2">
  <animate attributeName="r" repeatCount="indefinite" dur="1.7241379310344827s" values="0;16" keyTimes="0;1" keySplines="0 0.2 0.8 1" calcMode="spline"></animate>
  <animate attributeName="opacity" repeatCount="indefinite" dur="1.7241379310344827s" values="1;0" keyTimes="0;1" keySplines="0.2 0 0.8 1" calcMode="spline"></animate>
</circle>
</svg>`,
						}}
					></div>
				)}

				{loadingText && loadingText[index] && (
					<h4 className={`fade-in ${showText ? "active" : ""}`} style={loadingTextStyle}>{loadingText[index]}</h4>
				)}
			</div>
		</div>
	);
};

export default Loader;
